const createTrackProfiles = (seed) => {
    const variance = (seed % 17) / 17;
    return [
        { direction: 1, periods: [118 + (variance * 18), 52, 29], weights: [0.58, 0.27, 0.15] },
        { direction: -1, periods: [101, 61 + (variance * 14), 34], weights: [0.54, -0.3, 0.16] },
    ];
};

const trackOffset = (distance, amplitude, profile) => (
    amplitude * profile.direction * profile.weights.reduce((sum, weight, index) => (
        sum + (weight * Math.sin(distance / profile.periods[index]))
    ), 0)
);

const cursorIsOutside = ({ controlValue, controlRange, cursorRadius, pathOffset, roadHalf }) => (
    Math.abs((controlValue * controlRange) - pathOffset) > roadHalf - cursorRadius - 2
);

export {
    createTrackProfiles,
    cursorIsOutside,
    trackOffset,
};
